import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = ['cadenceUnit',
    'time',
    'timeWrapper',
    'repeatWrapper',
    'cronStringField',
    'day',
    'dayOfWeekSelector',
    'dayOfWeekSelectorWrapper',
    'repeat',
    'repeatCadence',
    'taskType',
    'form']

  static values = {
    cadenceUnit: String,
    selectedDays: Array,
    cronString: String,
    timezone: String,
    repeat: Number,
    repeatCadence: String
  }

  connect() {
    this.repeatTarget.value = this.repeatValue
    this.repeatCadenceTarget.value = this.repeatCadenceValue
  }


  toggleDay() {
    this.setSelectedDays()
  }

  setSelectedDays() {
    this.selectedDaysValue = this.dayTargets
      .filter(dayTarget => dayTarget.checked)
      .map(dayTarget => dayTarget.value)
  }

  clearSelections = () => {
    this.dayTargets.forEach(dayTarget => {
      dayTarget.checked = false
    })
    this.setSelectedDays()
  }

  repeatChanged(_event) {
    this.clampRepeatValue()
  }

  taskTypeChanged() {
    document.getElementById('scheduled_task_task_type').value = this.taskTypeTarget.value
  }

  clampRepeatValue() {
    if (this.repeatTarget.value > 23 && this.repeatCadenceValue === 'hour') {
      this.repeatTarget.value = 23
    }
    if (this.repeatTarget.value > 30 && this.repeatCadenceValue === 'minute') {
      this.repeatTarget.value = 30
    }
    if (this.repeatTarget.value < 1) {
      this.repeatTarget.value = 1
    }
    this.repeatValue = this.repeatTarget.value
  }

  repeatCadenceChanged(event) {
    this.repeatCadenceValue = event.target.value
    this.clampRepeatValue()
    this.updateForm()
  }

  cadenceChanged(event) {
    this.cadenceUnitValue = event.target.value
    if (this.cadenceUnitValue === 'weekly') {
      this.showDayOfWeekSelector()
    } else {
      this.hideDayOfWeekSelector()
    }

    if (this.cadenceUnitValue === 'repeating') {
      this.showRepeatingSelector()
    } else {
      this.hideRepeatingSelector()
    }
  }

  showRepeatingSelector() {
    this.timeWrapperTarget.classList.add('hidden')
    this.repeatWrapperTarget.classList.remove('hidden')
  }

  hideRepeatingSelector() {
    this.timeWrapperTarget.classList.remove('hidden')
    this.repeatWrapperTarget.classList.add('hidden')
  }

  showDayOfWeekSelector() {
    this.dayOfWeekSelectorWrapperTarget.classList.remove('hidden')
  }

  hideDayOfWeekSelector() {
    this.dayOfWeekSelectorWrapperTarget.classList.add('hidden')
    this.clearSelections()
  }

  updateForm() {
    this.clampRepeatValue()
    this.cronStringValue = this.generateCronString()
    this.cronStringFieldTarget.value = this.cronStringValue
  }

  generateCronString() {
    if (this.cadenceUnitValue === 'repeating') {
      if (this.repeatCadenceValue === 'minute') {
        return this.generateXMinCronString()
      } else {
        return this.generateXHourCronString()
      }
    }

    let [hour, min] = this.timeTarget.value.split(':')

    if (hour.startsWith('0')) {
      hour = hour.substring(1)
    }

    if (min.startsWith('0')) {
      min = min.substring(1)
    }

    if (this.cadenceUnitValue === 'weekly') {
      const days = this.selectedDaysValue.length === 0 ? '*' : this.selectedDaysValue.join(',')
      return `${min} ${hour} * * ${days} ${this.timezoneValue}`
    }

    return `${min} ${hour} * * * ${this.timezoneValue}`
  }

  generateXMinCronString() {
    if (this.repeatValue === 1) return `* * * * * ${this.timezoneValue}`
    return `*/${this.repeatValue} * * * * ${this.timezoneValue}`
  }

  generateXHourCronString() {
    if (this.repeatValue === 1) return `0 * * * * ${this.timezoneValue}`
    return `0 */${this.repeatValue} * * * ${this.timezoneValue}`
  }

  submitClicked(event) {
    event.preventDefault()
    this.updateForm()
    this.formTarget.submit()
  }
}
